module.exports = __webpack_public_path__ + "static/media/js-icon.cc334f46.png";